var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClosePopup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.8437 25.1869C1.45393 23.8006 1.70152 21.9073 3.58644 19.507L3.72129 19.3725C5.64483 17.4537 17.6788 6.41701 23.9649 2.08097C24.9778 1.65523 25.8711 1.83022 26.6446 2.60181L27.959 3.91287C27.7309 5.67927 26.8675 7.3143 25.3683 8.80973C17.2173 16.029 4.61484 26.9536 3.4233 25.7651L2.8437 25.1869Z",
    fill: "#5A5C5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.08441 1.45095C3.25813 0.289596 4.97003 0.823941 7.22597 3.05611C12.9065 9.34826 24.2516 20.9114 25.2655 21.9147L25.4055 22.0532C26.5715 23.2069 27.4629 23.9238 28.0915 24.2082C29.1546 25.6417 29.2413 26.8026 28.3476 27.6869L27.2239 28.7987C26.2987 29.7143 14.6834 19.1387 8.3716 12.8934C2.51176 7.09532 0.125133 3.65871 1.21541 2.57991L1.95832 1.57571L2.08441 1.45095Z",
    fill: "#5A5C5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClosePopup);
export default __webpack_public_path__ + "static/media/icon-close-popup.445f0942385836b0cc9a41651ec80360.svg";
export { ForwardRef as ReactComponent };